import type { Helpers } from '@wix/ricos/internal';
import { biStrategy } from '@wix/ricos/internal';
import { RICOS_VERSION } from '@wix/ricos/schema-next';
import React from 'react';

import { useVisitorId } from './use-visitor-id';

const BiContext = React.createContext<Helpers | undefined>(undefined);

export const BiProvider: React.FC<{ containerId: string; children: React.ReactNode }> = ({
  children,
  containerId,
}) => {
  const visitorId = useVisitorId();
  const biProps = React.useMemo(
    () =>
      biStrategy(
        '',
        '4b54e727-0f72-4e76-ab29-4666778c0ff0', // demo wix site. it looks that bi-events doesn't work with fake id https://vaidask4.wixsite.com/my-site-150
        RICOS_VERSION,
        RICOS_VERSION,
        {
          consumer: 'playground',
          postId: '',
          // @ts-ignore
          platform: 'playground',
          containerId,
          defaultParams: {
            visitorId,
          },
        }
      ),
    [containerId, visitorId]
  );
  return <BiContext.Provider value={biProps.helpers as Helpers}>{children}</BiContext.Provider>;
};

export const useBiCallbacks = () => {
  const ctx = React.useContext(BiContext);
  if (!ctx) {
    throw new Error('useBiSettings must be used within a BiProvider');
  }
  return ctx;
};
